import { render, staticRenderFns } from "./PaginationModal.vue?vue&type=template&id=5f02f822&scoped=true&"
import script from "./PaginationModal.vue?vue&type=script&lang=js&"
export * from "./PaginationModal.vue?vue&type=script&lang=js&"
import style0 from "./PaginationModal.vue?vue&type=style&index=0&id=5f02f822&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f02f822",
  null
  
)

export default component.exports